import { Component, Input } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { GameElement } from '../../../models/game-element.model';

import { TableBaseComponent } from '../table-base/table-base.component';

import { UserService } from '../../../../core/services/user.service';
import { ConfigurationService } from '../../../services/configuration.service';

@Component({
  selector: 'app-game-element-table',
  templateUrl: './game-element-table.component.html'
})
export class GameElementTableComponent extends TableBaseComponent<GameElement> {

  @Input() elementTypes: number[];
  @Input() detailLink = '/levels';

  tableConfig: any = this.getTableConfig('level');

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected config: ConfigurationService,
    protected userService: UserService
  ) {
    super(router, route, config, userService);
  }

  getGlobalFilterFields() {
    this.globalFilters = this.globalFilters || [{
      label: 'ID',
      field: 'id',
      active: this.showId
    }, {
      label: 'Name',
      field: 'name.value',
      active: true
    }];

    return this.globalFilters
      .filter(filter => filter.active)
      .map(filter => filter.field);
  }

  handleRowReorder(): void {
    if (this.options.canReorder) {
      this.onReorder.emit(this.data);
    }
  }
}
